<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="keyword"
          />

          <label class="search-label" >状态</label>
          <Select v-model="status" class="search-input" clearable>
            <Option
              v-for="item in statusIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >工作类型</label>
          <Select v-model="work_type_id" class="search-input" clearable>
            <Option
              v-for="item in workTypeIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >平台</label>
          <Select v-model="live_id" class="search-input" @on-change="liveChange" clearable>
            <Option
              v-for="item in liveIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >视频分类</label>
          <Select v-model="video_classify_id" class="search-input" @on-change="videoClassifyChange" clearable>
            <Option
              v-for="item in videoClassifyIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >执行账号</label>
          <Select v-model="user_id" class="search-input" clearable filterable>
            <Option
              v-for="item in userIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button @click="handleButtonSearch" class="search-btn"type="primary">搜索</Button>
        </Col>
      </Row>

      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="编辑合成视频"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
        ref="editMergeVideo"
       @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="detailModal"
      title="视频列表"
      footer-hide
      >
      <videoListForms :resetFlag="resetFlag"
        ref="videoListDetail"
       @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Forms from './edit_merge_video_form.vue'
import Tables from '_c/tables/table-only.vue'
import videoListForms from './see_video_list_form.vue'

import config from '@/config'

import { getMergeVideoList, editMergeVideoTask, finishMergeVideoTask,
  getShortVideoWorkTypeList, getShortVideoClassify, getLiveType,
  getStrategyUser, endMergeVideo, resetMergeVideo } from '@/api/data'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
export default {
  name: 'finance',
  components: {
    Tables,
    Forms,
    videoListForms
  },
  data () {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addWxChat: false,
      addModal: false,
      editModal: false,
      resetFlag: false,
      detailModal: false,
      editData: {},
      tableLoading: true,
      editMaxCount: false,
      allMoney: 0.0,
      startTime: '',
      endTime: '',
      wxContacts: [],
      statusIds: [{ id: -1, name: '全部' }, { id: 0, name: '待处理' }, { id: 1, name: '合成中' }, { id: 3, name: '合成失败' }],
      live: '',
      user: '',
      user_id: '',
      keyword: '',
      userIds: [],
      liveIds: [],
      workTypeIds: [],
      videoClassifyIds: [],
      live_id: '',
      work_type_id: '',
      video_classify_id: '',
      status: -1,
      columns: [
        { title: 'id',
          width: 100,
          align: 'center',
          key: 'id',
          render: (h, params) => {
            let texts = params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.id
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          } },
        { title: 'id', width: 100, key: 'id', editable: true, align: 'center' },
        {
          title: '自动化',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            var texts = '手动'
            if (params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.auto) {
              texts = '自动'
            }
            return h(
              'div',
              {
                props: {},
                style: {
                  color: params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.auto ? '#ff0000' : '#515a6e'
                }
              },
              texts
            )
          }
        },
        { title: '执行人',
          key: 'nickname',
          editable: true,
          align: 'center',
          render: (h, params) => {
            var texts = ''
            var list = params.row.covertFace.covertAudio.translateText.list
            if (list.length != 0) {
              for (var i = 0; i < list.length; i++) {
                texts += list[i].username + '\n'
              }
            }
            return h(
              'pre',
              texts
            )
          } },
        { title: '语言',
          key: 'work_type_name',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = params.row.covertFace.covertAudio.translateText.list[0].language
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          } },
        { title: '类型',
          key: 'source_audio_name',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.work_type_name)
          } },
        { title: '分类',
          key: 'video_classify',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.video_classify
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          } },
        //   { title: "文案" , key: "srt_path", editable: true, align: "center", render: (h, params) => {
        //         return h('div', [
        //         // 显示的位置上方
        //           h('Tooltip', {
        //             props: { placement: 'top' ,transfer: true}
        //           }, [
        //             h('span', {
        //               style: {
        //                 display: 'inline-block',
        //                 width: '70px',
        //                 overflow: 'hidden',
        //                 textOverflow: 'ellipsis',
        //                 whiteSpace: 'nowrap',
        //               },
        //             }, params.row.covertFace.covertAudio.translateText.translate_text),
        //             // 显示的内容
        //             h('span', {
        //               slot: 'content',
        //               style: { whiteSpace: 'normal', wordBreak: 'break-all' }
        //             },params.row.covertFace.covertAudio.translateText.translate_text)
        //           ])
        //         ])
        //       }
        // },
        //   { title: "字幕" , key: "srt_path", editable: true, align: "center", render: (h, params) => {
        //       return params.row.covertFace.covertAudio.srt_path && params.row.covertFace.covertAudio.srt_path.length > 0 != '' ?h("div", [
        //         h(
        //           "Button",
        //           {
        //             props: {
        //               type: "primary",
        //               size: "small",
        //             },
        //             style: {
        //               marginRight: "5px",
        //             },
        //             on: {
        //               click: () => {
        //                 this.download(params.row.covertFace.covertAudio.srt_path);
        //               },
        //             },
        //           },
        //           "下载"
        //         )
        //       ]): h('span', '');
        //     }},
        //   { title: "音频" , key: "srt_path", editable: true, align: "center", render: (h, params) => {
        //       return params.row.covertFace.covertAudio.source_path && params.row.covertFace.covertAudio.source_path.length > 0 != '' ?h("div", [
        //         h(
        //           "Button",
        //           {
        //             props: {
        //               type: "primary",
        //               size: "small",
        //             },
        //             style: {
        //               marginRight: "5px",
        //             },
        //             on: {
        //               click: () => {
        //                 this.download(params.row.covertFace.covertAudio.source_path);
        //               },
        //             },
        //           },
        //           params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id == 4?"查看":"下载"
        //         )
        //       ]): h('span', '');
        //     }},
        { title: '合并前视频',
          key: 'srt_path',
          editable: true,
          align: 'center',
          render: (h, params) => {
            var url = ''
            if (params.row.covertFace.output_video_path == null) {
              if (params.row.covertFace.covertAudio != null) {
                if (params.row.covertFace.covertAudio.translateText != null) {
                  if (params.row.covertFace.covertAudio.translateText.checkSrtTask != null) {
                    if (params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask != null) {
                      url = params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.url
                    }
                  }
                }
              }
            } else {
              url = params.row.covertFace.output_video_path
            }
            return ((url != null && url.length > 0 != '') || (params.row.covertFace.list != null && params.row.covertFace.list.length != 0)) ? h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.download(url, params)
                    }
                  }
                },
                params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id == 4 ? '查看' : '下载'
              )
            ]) : h('span', '')
          } },
        // { title: "钩子视频" , key: "srt_path", editable: true, align: "center", render: (h, params) => {
        //     var url = baseUrl =='https://in.sinano-ai.com/api' ?params.row.gvl_id_url: params.row.gvl_url
        //     return url && url.length > 0 != '' ?h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "primary",
        //             size: "small",
        //           },
        //           style: {
        //             marginRight: "5px",
        //           },
        //           on: {
        //             click: () => {
        //               this.download(url);
        //             },
        //           },
        //         },
        //         "下载"
        //       )
        //     ]): h('span', '');
        //   }},
        { title: '合并后视频',
          key: 'srt_path',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return params.row.output_video_path && params.row.output_video_path.length > 0 != '' ? h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.download(params.row.output_video_path)
                    }
                  }
                },
                '下载'
              )
            ]) : h('span', '')
          } },
        {
          title: '状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            var texts = '已完成'
            if (params.row.status == 0) {
              texts = '待处理'
            } else if (params.row.status == 1) {
              texts = '合成中'
            } else if (params.row.status == 2) {
              texts = '合成完毕'
            } else if (params.row.status == 3) {
              texts = '合成失败'
            } else if (params.row.status == 5) {
              texts = '任务终止'
            }
            var color = '#03A9F4'
            if (params.row.status == 3) {
              color = '#ff0000'
            } else if (params.row.status == 4) {
              color = '#515a6e'
            }

            return h(
              'div',
              {
                props: {},
                style: {
                  color: color
                }
              },
              texts
            )
          }
        },
        { title: '创建时间', key: 'create_time', editable: true, align: 'center' },
        { title: '完成时间', key: 'finish_time', editable: true, align: 'center' },
        {
          title: 'Handle',
          key: 'handle',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params)
                    }
                  }
                },
                '编辑'
              ),
              params.row.status == 3 || params.row.status == 1 ? h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handReset(params)
                    }
                  }
                },
                '重新处理'
              ) : h('span', ''),
              params.row.status != 4 && params.row.status != 5 ? h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleFinish(params)
                    }
                  }
                },
                '完成'
              ) : h('span', ''),
              params.row.status != 5 ? h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleEnd(params)
                    }
                  }
                },
                '终止'
              ) : h('span', '')
            ])
          }
        }
      ],
      tableData: []
    }
  },
  watch: {
    '$route': function (to, from) {
      // 路由发生变化时，重新获取数据
      this.handleSearch()
    }
  },
  methods: {
    handReset (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认重新处理该任务？</p>',
        onOk: () => {
          resetMergeVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },

    handleButtonSearch () {
      this.page = 1
      this.handleSearch()
    },
    handleEnd (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认终止任务？</p>',
        onOk: () => {
          endMergeVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    download (url, params = null) {
      if (params == null) {
        window.open(url, '_blank')
      } else {
        if (params.row.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id != 4) {
          window.open(url, '_blank')
        } else {
          this.detailModal = true
          this.$refs.videoListDetail.setEditData(params.row.covertFace)
        }
      }
    },
    showEditModal (params) {
      this.addModal = true
      this.resetFlag = !this.resetFlag
      this.$refs.editMergeVideo.setEditData(params.row)
    },
    addSumit (formValidate) {
      const data = {
        output_video_path: formValidate.video_path
      }
      editMergeVideoTask(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success('成功!')
            this.addModal = false
            this.handleSearch()
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    cancel () {},
    changePage (page) {
      this.page = page
      this.handleSearch()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleSearch () {
      this.setTableLoading(true)
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.status,
        live_id: this.live_id,
        keyword: this.keyword,
        user_id: this.user_id,
        work_type: this.work_type_id,
        video_classify: this.video_classify_id
      }
      getMergeVideoList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.setTableLoading(false)
      })
    },
    handleFinish (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认提交任务？</p>',
        onOk: () => {
          finishMergeVideoTask(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    setTableLoading (state) {
      this.tableLoading = state
    },
    videoClassifyChange (value) {
      this.getStrategyUser()
    },
    liveChange (value) {
      this.getStrategyUser()
    },
    getStrategyUser () {
      var params = {
        short_video_classify: this.video_classify_id,
        live_id: this.live_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          data.push({ id: user.id.toString(), name: user.username })
        }
        this.userIds = data
      })
    }
  },
  mounted () {
    this.getStrategyUser()
    this.handleSearch()
    getLiveType({}).then((res) => {
      if (res.data.code == 200) {
        var lives = res.data.data
        var data = new Array()
        for (var i = 0; i < lives.length; i++) {
          data[i] = { id: lives[i].id.toString(), name: lives[i].name }
        }
        this.liveIds = data
      }
    })

    getShortVideoWorkTypeList().then((res) => {
      var workType = res.data.data.records
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.workTypeIds = data
    })

    getShortVideoClassify({}).then((res) => {
      var workType = res.data.data.records
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.videoClassifyIds = data
    })
  }
}
</script>
